import { createGlobalStyle } from 'styled-components';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : globalStyles
Description : Componente que contienen estilos globales para algunos de los componentes de la aplicación
Date Autor Modification
================================================================================
29/10/2021 Santiago Coca Rojas Creación – Se crea el componente desde cero.
================================================================================ */

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    background-color: var(--surface-100);;
    font-family: Comic-Sans, Helvetica, Sans-Serif;
  };
  h2 {
    font: 33px sans-serif;
    color: black;
    @media screen and (max-width: 960px){
        display: none;
    }
  };
  /* form {
    width: auto;
    padding-top: 20px;
    border-radius: 80px;
    border-color: black;
    background-color: white;
    @media screen and (max-width: 960px){
        align-content: center;
        margin-top: 50px;
    }
  }; */
  /* button {
    background-color: #1061a2;
    color: white;
    border-radius: 8px;
    &:hover a{
        color: white;
    }
    &:hover{
        background-color:#0d6efd;
    }
    &:disabled{
        border: 1px solid #999999;
        background-color: #cccccc;
        color: #666666;
    }
  }; */
  /* label {
    color: #3498DB;
    @media screen and (max-width: 960px){
        align-content: center;
        font-size: 13px;
        margin: auto;
    }
  }; */
  /* input {
    padding: 0.5em;
	  width:100%;
    margin-top: -3px;
    margin-bottom: -3px;
    border: 1px solid;
    border-radius: 3px;
    border-color: #3498DB;
    @media screen and (max-width: 960px){
        align-content: center;
        display: block
    }
  }; */
  /* select {
    color: palevioletred;
    background: papayawhip;
    border: none;
    border-radius: 3px;
    option {
      color: black;
      background: white;
    };
  }; */
  /* table {
    border-collapse: collapse;
    border-radius: 5px 5px 0 0;
    overflow: hidden;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
    @media screen and (max-width: 960px){
      margin: 100px 0;
    }
  }; */
  /* th {
    border-bottom: 1px solid #d1cccc;
    border-right: 1px solid #d1cccc;
    &:last-child {
        border-right: 0;
    } 
  };
  td {
    border-bottom: 1px solid #d1cccc;
    border-right: 1px solid #d1cccc;
    border-bottom: 0;
    &:last-child {
        border-right: 0;
    }
  };
  tr {

  };
  h1 {

  }; */
  /* thead {
    background-color: #1061a2;
    color: #ffffff;
    font-weight: bold;
  }; */
  nav {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    position: sticky;
    top: 0;
    @media screen and (max-width: 960px){
        display: flex;
        flex-direction: column;
        width: 10%;
        position: absolute;
    }
  };
  ul {
    display: grid;
    grid-gap: 8px;
    list-style: none;
    text-align: center;
    width: 101%;
    /*@media screen and (max-width: 960px){
        flex-direction: column;
        padding: 2rem;
        border: 2px solid;
        border-radius: 8px;
        border-color: black;  
        width: 25%;
        height: 200hv;
    }*/
  };
  /* h3 {
    font: 22px sans-serif;
    text-align: center;
    position: relative;
    z-index: 1;
  } */
`;

export default GlobalStyle;